import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GET_CURRENT_USER_ORGANIZATION_LIST_PATH } from 'ze-api-contract/user-v2/get-current-user-organizations-list';
const _currentUserOrganizationListKeys = createQueryKeys('user', {
    available: {
        queryKey: [
            GET_CURRENT_USER_ORGANIZATION_LIST_PATH
        ]
    }
});
export const currentUserOrganizationListKeys = _currentUserOrganizationListKeys;
